export default {
    setAppZoom(zoom) {
        if (zoom >= 100 && zoom <= 200) {
            document.body.style.zoom = `${zoom}%`
            document.body.classList.toggle("font-size", zoom > 100)
            if (typeof InstallTrigger !== 'undefined') {
                document.body.style.transform = `scale(${zoom / 100})`
                document.body.style.transformOrigin = "0 0"

                if (zoom === 100) {
                    document.body.style.width = "auto"
                } else if (zoom === 125) {
                    document.body.style.width = "79vw"
                } else if (zoom === 150) {
                    document.body.style.width = "65vw"
                } else if (zoom === 175) {
                    document.body.style.width = "55vw"
                } else if (zoom === 200) {
                    document.body.style.width = "49vw"
                }
            }
        }
    }
}